export interface TrackerFormProps {
  isChecked: boolean;
  onChangeState: () => void;
  disabledSelect: boolean;
}

export enum TrackerFormValues {
  SERVICE = 'service',
  API_URL = 'trackerApiUrl', // FormModalCompanyValues.TRACKER_API_URL
  API_KEY = 'trackerApiKey', // FormModalCompanyValues.TRACKER_API_KEY
}
